<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.333 29.333">
  <path d="M9.167 24.235h-4.01V11.287h4.01zm.4-17.074a2.349 2.349 0 10-4.698 0 2.349 2.349 0 004.698 0zm14.61 9.95c0-3.476-.734-6.054-4.794-6.054-1.951 0-3.262.976-3.796 1.991v-1.761H11.69v12.948h3.896v-6.43c0-1.682.428-3.314 2.514-3.314 2.059 0 2.126 1.925 2.126 3.421v6.323h3.953V17.11zm5.156 8.785V3.437A3.44 3.44 0 0025.896 0H3.437A3.44 3.44 0 000 3.437v22.459a3.44 3.44 0 003.437 3.437h22.459a3.44 3.44 0 003.437-3.437zM25.896 2.292c.632 0 1.145.513 1.145 1.145v22.459c0 .632-.513 1.145-1.145 1.145H3.437a1.146 1.146 0 01-1.145-1.145V3.437c0-.632.513-1.145 1.145-1.145z" />
</svg>
</template>

<script>
export default {

}
</script>

<style>

</style>
